import { useState } from "react";
import { direccionGarantia, garantias, listaGarantias, segurosIncendio, tipoPropiedad, ValueDto } from "../models/garantias";
import { deleteTipoGarantia, getDireccionGarantia, getEstadoBienRaiz, getGarantiasService, getGarantiasTipoPropiedad, getInstitucionFinanciera, getListaGarantias, getSeguroGarantias, getTipoBienRaiz, getTipoConstruccion, getTipoHipoteca } from "../services/servicesGarantias";
import { selectorTransversal } from "../../../dtos/selector";
import { getCiudades, getComunaPorId } from "../services/servicesParticipantes";
import { ciudades, comunas } from "../models/participantes";
import { getValoresDominio } from "../../../services/servicesDominio";
import { Dominios, StatusCode } from "../../../utils/enums";
import { UseFormReset } from "react-hook-form";
import { AxiosResponse } from "axios";
import { useToast } from "../../../hooks/useToast";
import { ListResponseDto } from "../../../dtos/ListResponseDto";

export function useGarantias() {
    const { addToast } = useToast();
    const [hipotecas, setHipotecas] = useState<selectorTransversal[]>([]);
    const [listEstadoBienRaiz, setListEstadoBienRaiz] = useState<selectorTransversal[]>([]);
    const [listTipoBienRaiz, setListTipoBienRaiz] = useState<selectorTransversal[]>([]);
    const [listTipoConstruccion, setListTipoConstruccion] = useState<selectorTransversal[]>([]);
    const [listInstitucionFinan, setListInstitucionFinan] = useState<selectorTransversal[]>([]);
    const [listaTipoPropiedad, setListaTipoPropiedad] = useState<selectorTransversal[]>([]);
    const [tipoPropiedad, setTipoPropiedad] = useState<tipoPropiedad>();
    const [listaGarantias, setListaOrigenes] = useState<listaGarantias[]>([]);
    const [ciudades, setCiudades] = useState<selectorTransversal[]>([]);
    const [comunas, setComunas] = useState<selectorTransversal[]>([]);
    const [defaultNuevo, setDefaultNuevo] = useState<garantias>({
        fechaTasacion: new Date(),
        empresaTasadora: '',
        tipoConstruccion: '',
        añoConstruccion: 0,
        // rolPropiedad: '',
        tipoBienRaiz: '',
        descripcionGarantia: '',
        valorGarantia: 0,
        valorLiquidacion: 0,
        m2Construidos: 0,
        m2Terreno: 0,
        tieneHipoteca: false,
        pagaIva: false,
        tipoHipoteca: '',
        estadoBienRaiz: '',
        rutInstitucionFinanciera: null
    });
    const [defaultValues, setDefaultValues] = useState<garantias>({
        fechaTasacion: new Date(),
        empresaTasadora: '',
        tipoConstruccion: '',
        añoConstruccion: 0,
        // rolPropiedad: '',
        tipoBienRaiz: '',
        descripcionGarantia: '',
        valorGarantia: 0,
        valorLiquidacion: 0,
        m2Construidos: 0,
        m2Terreno: 0,
        tieneHipoteca: false,
        pagaIva: false,
        tipoHipoteca: '',
        estadoBienRaiz: '',
        rutInstitucionFinanciera: null
    });
    const [tipoPropiedadDireccion, setTipoPropiedadDireccion] = useState<direccionGarantia>({
        direccionParticular: '',
        comuna: '',
        ciudad: '',
        tipoPropiedad: '',
        rutVendedor: '',
        nombreVendedor: '',
        emailVendedor: '',
        otrosVendedores: '',
        rutInmobiliaria: '',
        nombreInmobiliaria: '',
        rolPropiedad: ''
    });
    const [defaultValueSeguro, setDefaultValueSeguro] = useState<segurosIncendio>({
        mutuoId: 0,
        seguroId: 0,
        tipoSeguro: '',
        codigoPoliza: '',
        codigoInterno: '',
        tasa: 0,
        montoPrimaAnual: 0,
        montoAsegurado: 0,
        mesesGratuidad: 0,
        nombreCompania: null,
        montoPrimaDividendo: 0,
        cantidadCuotasAnuales: 0,
        tasaSobrePrima: 0,
    });


    const obtenerLista = async (idMutuo: number) => {
        const resp: AxiosResponse<ListResponseDto<listaGarantias>> = await getListaGarantias(idMutuo);
        if (resp.status === StatusCode.Ok) {
            setListaOrigenes([...resp.data.items]); // Forzar una nueva referencia para asegurar que el componente garantiaForm se actualice
        }
    }

    const obtenerDireccionGarantia = async (idMutuo: number) => {

        const respDireccion = await getDireccionGarantia(idMutuo);
        if (respDireccion.status === 200) {
            const garantiasData: direccionGarantia = await respDireccion.data();
            setTipoPropiedadDireccion((prev) => ({
                ...prev,
                ...garantiasData,
            }));
        }
    }

    const obtenerTipoPropiedadPorId = async (idMutuo: number) => {
        const resp = await getGarantiasTipoPropiedad(idMutuo)
        if (resp && resp.status === 200) {
            const data: direccionGarantia = await resp.data;
            setTipoPropiedadDireccion((prev) => ({
                ...prev,
                ...data,
            }));
        }
    }

    const obtenerDatosGarantiaDireccion = async (idMutuo: number, reset: UseFormReset<direccionGarantia>) => {
        try {
            const [respDireccion, respTipoPropiedad] = await Promise.all([
                getDireccionGarantia(idMutuo),
                getGarantiasTipoPropiedad(idMutuo),
            ]);

            const garantiasData: direccionGarantia = respDireccion.status === StatusCode.Ok ? await respDireccion.data : {};
            const tipoPropiedadData: direccionGarantia = respTipoPropiedad.status === StatusCode.Ok ? await respTipoPropiedad.data : {};
            const data: direccionGarantia = ({
                ...garantiasData,
                ...tipoPropiedadData,
            })
            setTipoPropiedadDireccion(data);
            if (data.ciudad) {
                comunaPorId(data.ciudad);
            }

            reset(data);
        } catch (error) {
            console.error("Error al obtener los datos de garantía:", error);
        }
    };


    const obtenerGarantias = async (idMutuo: number, idGarantias: number) => {

        const respGarantias = await getGarantiasService(idMutuo, idGarantias);
        if (respGarantias.status === StatusCode.Ok) {
            setDefaultValues(respGarantias.data);
        }
    }

    const listaHipoteca = async () => {

        const resp :AxiosResponse<ListResponseDto<ValueDto>> = await getTipoHipoteca();
        if (resp.status === 200) {
            const hipotecas: selectorTransversal[] = await resp.data.items;
            setHipotecas(hipotecas);
        }
    }

    const listaEstadoBienRaiz = async () => {

        const resp :AxiosResponse<ListResponseDto<ValueDto>>  = await getEstadoBienRaiz();
        if (resp.status === 200) {
            const response: selectorTransversal[] = await resp.data.items;
            setListEstadoBienRaiz(response);
        }
    }

    const listaTipoBienRaiz = async () => {

        const resp :AxiosResponse<ListResponseDto<ValueDto>> = await getTipoBienRaiz();
        if (resp.status === 200) {
            const response: selectorTransversal[] = await resp.data.items;
            setListTipoBienRaiz(response)
        }
    }

    const listaTipoConstruccion = async () => {

        const resp :AxiosResponse<ListResponseDto<ValueDto>>= await getTipoConstruccion();
        if (resp.status === 200) {
            const response: selectorTransversal[] = await resp.data.items;
            setListTipoConstruccion(response);
        }
    }

    const listarInstitucionFinanciera = async () => {

        const resp :AxiosResponse<ListResponseDto<ValueDto>>= await getInstitucionFinanciera();
        if (resp.status === 200) {
            const response: selectorTransversal[] = await resp.data.items;
            setListInstitucionFinan(response);
        }
    }

    const listarSelectores = async () => {
        listaHipoteca();
        listaEstadoBienRaiz();
        listaTipoBienRaiz();
        listaTipoConstruccion();
    }

    const comunaPorId = async (idCiudad: string) => {
        const resp: AxiosResponse<ListResponseDto<comunas>> | undefined = await getComunaPorId(idCiudad)
        if (resp && resp.status === 200) {
            const data: comunas[] = await resp.data.items;
            let comuna: selectorTransversal[] = [];

            data.map((x) => comuna.push({ value: (x.codigo), label: x.nombre }));
            setComunas(comuna);
        }
    }

    const obtenerCiudades = async () => {
        const resp: AxiosResponse<ListResponseDto<ciudades>> = await getCiudades();

        if (resp && resp.status === 200) {
            const data: ciudades[] = await resp.data.items;
            let ciudades: selectorTransversal[] = [];

            data.map((x) => ciudades.push({ value: (x.codigo), label: x.nombre }));
            setCiudades(ciudades);
        }
    }

    const listarTipoPropiedad = async (dominio: Dominios) => {
        const resp: AxiosResponse<ListResponseDto<selectorTransversal>> = await getValoresDominio(dominio)
        if (resp.status === StatusCode.Ok) {
            const data: selectorTransversal[] = await resp.data.items;
            setListaTipoPropiedad(data);
        }
    }

    const obtenerSeguroIncendio = async (idMutuo: number) => {

        const respSeguro = await getSeguroGarantias(idMutuo);
        if (respSeguro.status === StatusCode.Ok) {
            const seguro: segurosIncendio = await respSeguro.data;
            setDefaultValueSeguro(seguro);
        }
    }

    const eliminarGarantias = async (idMutuo: number, idGarantias: number, renderizar: () => Promise<void>) => {

        const respSeguro = await deleteTipoGarantia(idMutuo, idGarantias);
        if (respSeguro.status === StatusCode.NoContent) {
            renderizar();
            addToast({
                mostrar: true,
                titulo: 'Confirmación',
                tipo: 'Success',
                mensaje: 'La garantía ha sido eliminada correctamente.'
            });
        }
    }

    return {
        obtenerLista,
        obtenerDireccionGarantia,
        obtenerGarantias,
        listaHipoteca,
        listaEstadoBienRaiz,
        listaTipoBienRaiz,
        listaTipoConstruccion,
        listarSelectores,
        comunaPorId,
        setDefaultValues,
        listarTipoPropiedad,
        obtenerTipoPropiedadPorId,
        setTipoPropiedadDireccion,
        obtenerCiudades,
        obtenerDatosGarantiaDireccion,
        listarInstitucionFinanciera,
        obtenerSeguroIncendio,
        eliminarGarantias,
        tipoPropiedad,
        hipotecas,
        listEstadoBienRaiz,
        listTipoBienRaiz,
        listTipoConstruccion,
        listaGarantias,
        defaultValues,
        ciudades,
        comunas,
        listaTipoPropiedad,
        tipoPropiedadDireccion,
        listInstitucionFinan,
        defaultValueSeguro,
        defaultNuevo
    }
}

